// extracted by mini-css-extract-plugin
export default {"statuteContainer":"StatuteModal_statuteContainer__X4ZvP"};